var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ag-charts-vue',{staticStyle:{"width":"100%","height":"150px"},attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }